import axios from 'axios';

import { getSchedulingServerURL } from '../../../HarverPages/shared/helper';
import { INTERVIEW_STATUS } from '../domains';

export interface InterviewDetails {
    status: INTERVIEW_STATUS;
    organizationName: string;
}
export async function getInterviewDetails(calendarEventId: string): Promise<InterviewDetails> {
    const apiEndpoint = `${getSchedulingServerURL()}/interview/details?ref=${calendarEventId}`;
    const { data } = await axios.get(apiEndpoint);

    return data;
}
